import { TabComponents } from 'common/types/tabsV2';
import { CandidateProfileAnalysisTab } from 'modules/candidate-profile-analysis/utils/getCandidateProfileAnalysisTabs';
import { CandidateProfileAnalysisDetails } from 'modules/candidate-profile-analysis/tabs/CandidateProfileAnalysisDetails';
import { CandidateProfileAnalysisConversation } from 'modules/candidate-profile-analysis/tabs/CandidateProfileAnalysisConversation';
import { CandidateProfileAnalysisInterviewTranscripts } from 'modules/candidate-profile-analysis/tabs/CandidateProfileAnalysisInterviewTranscripts';
import { CandidateProfileAnalysisNotes } from 'modules/candidate-profile-analysis/tabs/CandidateProfileAnalysisNotes';
import { CandidateByCandidateProfile } from 'modules/candidate-profile-analysis/types/CandidateByCandidateProfile';

type CandidateProfileAnalysisComponentsProps = {
  candidate: CandidateByCandidateProfile | null;
};

export const getCandidateProfileAnalysisComponents = ({
  candidate
}: CandidateProfileAnalysisComponentsProps): TabComponents<CandidateProfileAnalysisTab> => ({
  Details: <CandidateProfileAnalysisDetails candidate={candidate} />,
  Conversation: (
    <CandidateProfileAnalysisConversation
      conversationId={candidate?.conversationId ?? null}
    />
  ),
  'Interview transcripts': (
    <CandidateProfileAnalysisInterviewTranscripts
      calendarBookingId={candidate?.conversation?.calendarBookingId ?? null}
    />
  ),
  Notes: <CandidateProfileAnalysisNotes candidateId={candidate?.id ?? null} />
});
